module.exports = __webpack_public_path__ + "static/media/hash.64a9940b.svg";